<template>
    <div class="apprentice-simple-card quest-mission">
        <div class="row">
            <div :class="preview === 0 ? 'col-12 col-md-8 col-xl-9' : 'col-12'">
                <div class="quest-mission-info">
                    <div class="component-title">
                        <h5 class="title">{{ $t('quest.information') }}</h5>
                        <b-button
                            class="btn-quest-cancel"
                            v-if="usermission.status === 1"
                            variant="danger"
                            @click="cancelMission">
                            <i class="fas fa-fw fa-times"></i>{{ $t('common.cancel') }}
                        </b-button>
                    </div>

                    <p class="description">
                        <!-- TODO: Shorten key -->
                        {{
                            $t(
                                'quest.read_the_assignment_below_carefully_there_may_be_attachments_files_or_links_that_you_also_need_to_complete_the_assignment_you_can_submit_your_answer_under_the_assignment_keep_a_close_eye_on_the_schedule_which_is_indicated_here_on_the_right',
                            )
                        }}
                    </p>
                </div>
            </div>

            <div
                class="col-12 col-md-4 col-xl-3 margin-bottom"
                v-if="preview === 0">
                <div class="apprentice-simple-card-100-height quest-user-mission-card quest-user-mission-planning-card">
                    <div class="quest-user-mission-card-header">
                        <h5 class="title">Planning</h5>
                    </div>

                    <div class="quest-user-mission-card-content">
                        <design-2021-quest-deadline-progress-component
                            :deadline="usermission.deadline"></design-2021-quest-deadline-progress-component>

                        <p class="h4">{{ usermission.deadline.longdate }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div
                class="margin-bottom"
                :class="quest.skills.length > 0 ? 'col-12 col-md-8 col-xl-9' : 'col-12'">
                <div class="apprentice-simple-card-100-height quest-user-mission-card quest-assignment-card">
                    <div class="quest-user-mission-card-header">
                        <h5 class="title">{{ $t('quest.assignment') }}</h5>
                    </div>

                    <div class="quest-user-mission-card-content">
                        <design-2021-apprentice-display-html-component
                            class="description"
                            :html-content="mission.description"></design-2021-apprentice-display-html-component>

                        <p class="group-size">
                            <b>{{ $t('quest.max_group_size') }}</b> {{ mission.group_size }}
                        </p>

                        <div
                            class="attachments"
                            v-if="mission.files.length > 0">
                            <div class="component-title">
                                <h5 class="title">{{ $t('quest.attachments') }}</h5>
                            </div>

                            <div
                                class="quest-attachment-files file"
                                v-for="file in mission.files"
                                :key="`attachment-file-${file.id}`">
                                <div
                                    class="icon icon-type"
                                    :class="getFileType(file.extension)"></div>
                                <div class="title">
                                    {{ file.name }}
                                    <div class="file-size text-muted">
                                        {{ file.size }}
                                    </div>
                                </div>
                                <div class="download-file">
                                    <b-button
                                        class="btn-download btn-file-download"
                                        variant="primary-icon-only"
                                        @click="goToFile(file.path)">
                                    </b-button>
                                </div>
                            </div>
                        </div>

                        <div
                            class="links"
                            v-if="mission.links.length > 0">
                            <div class="component-title">
                                <h5 class="title">Links</h5>
                            </div>

                            <div class="links-items">
                                <div
                                    class="link-item"
                                    v-for="link in mission.links">
                                    <div class="link-name">{{ link.name }}</div>
                                    <div class="link-icon">
                                        <a
                                            class="btn btn-view btn-primary-icon-only"
                                            :href="link.url"
                                            target="_blank">
                                            <i class="fa fa-link fa-fw"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="col-12 col-md-4 col-xl-3 margin-bottom"
                v-if="quest.skills.length > 0">
                <div class="apprentice-simple-card-100-height quest-user-mission-card">
                    <div class="quest-user-mission-card-header">
                        <h5 class="title">{{ $t('quest.skills') }}</h5>
                    </div>

                    <div class="quest-user-mission-card-content">
                        <div v-for="skill in quest.skills">
                            <h6>{{ skill.name }}</h6>
                            <b-progress
                                class="mb-3"
                                :value="skill.values[0].value"
                                max="9"
                                show-value></b-progress>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="apprentice-simple-card-100-height quest-user-mission-card quest-user-mission-send-in-card"
            v-if="preview === 0">
            <div class="quest-user-mission-card-header">
                <h5 class="title">{{ $t('quest.submit') }}</h5>
            </div>

            <div class="quest-user-mission-card-content">
                <div class="tabs apprentice-pills-tab row">
                    <div class="col-12 col-sm-3">
                        <ul
                            class="nav flex-column nav-pills quest-mission-send-in-tab"
                            role="tablist">
                            <li class="nav-item">
                                <a
                                    class="nav-link active"
                                    data-toggle="tab"
                                    href="#files-tab"
                                    role="tab"
                                    aria-controls="files-tab"
                                    aria-selected="true"
                                    ><i
                                        class="fa fa-cloud-upload-alt text-primary ml-2 fa-fw"
                                        style="margin-right: 10px"></i>
                                    {{ $t('quest.upload') }}
                                </a>
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#onlineeditor-tab"
                                    role="tab"
                                    aria-controls="onlineeditor-tab"
                                    aria-selected="false"
                                    ><i
                                        class="fa fa-file-word text-primary ml-2 fa-fw"
                                        style="margin-right: 10px"></i>
                                    Word online
                                </a>
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#links-tab"
                                    role="tab"
                                    aria-controls="links-tab"
                                    aria-selected="false"
                                    ><i
                                        class="fa fa-link text-primary ml-2 fa-fw"
                                        style="margin-right: 10px"></i>
                                    Link
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-9">
                        <div class="tab-content tab-content-vertical">
                            <div
                                class="tab-pane fade show active"
                                id="files-tab"
                                role="tabpanel"
                                aria-labelledby="address-tab">
                                <h4 class="card-title">{{ $t('quest.upload_files') }}</h4>
                                <p class="card-description">
                                    {{ $t('quest.upload_the_files_below_that_you_want_to_submit_for_this_assignment') }}
                                </p>
                                <b-form-file
                                    class="apprentice-file-upload"
                                    v-model="files"
                                    :state="Boolean(files)"
                                    @input="uploadFiles"
                                    :placeholder="$t('quest.choose_a_file_or_drag_it_here')"
                                    :drop-placeholder="$t('quest.drag_the_file_here')">
                                </b-form-file>

                                <div
                                    class="files"
                                    v-if="usermission.files.length > 0">
                                    <div
                                        class="uploaded-file"
                                        v-for="file in usermission.files">
                                        <div
                                            class="icon btn-video-icon"
                                            :class="getFileType(file.extension)"></div>
                                        <div class="title">
                                            {{ file.name }}
                                            <div class="file-size text-muted">
                                                {{ file.size }}
                                            </div>
                                        </div>
                                        <div class="actions">
                                            <b-button
                                                class="btn-remove btn-remove-file"
                                                v-b-tooltip.hover
                                                v-if="canEdit"
                                                variant="danger-icon-only"
                                                :title="$t('quest.drag_the_file_here')"
                                                @click="deleteFile(file.id)">
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="tab-pane fade"
                                id="onlineeditor-tab"
                                role="tabpanel"
                                aria-labelledby="onlineeditor-tab">
                                <h4 class="card-title">Online editor</h4>
                                <p class="card-description">
                                    {{
                                        $t(
                                            'quest.work_online_in_word_before_submitting_your_assignment_click_the_button_below_to_start_word',
                                        )
                                    }}
                                </p>
                                <p>&nbsp;</p>
                                <a
                                    class="btn btn-sm btn-primary"
                                    :href="routes.quest(projectId) + '/mission/' + mission.id + '/word'"
                                    >{{ $t('quest.open_word') }}</a
                                >
                            </div>
                            <div
                                class="tab-pane fade"
                                id="links-tab"
                                role="tabpanel"
                                aria-labelledby="links-tab">
                                <h4 class="card-title">{{ $t('quest.submit_links') }}</h4>
                                <p class="card-description">
                                    {{ $t('quest.fill_in_the_link_below_to_the_file_or_webpage_to_submit_this') }}
                                </p>

                                <div class="form-group">
                                    <label>{{ $t('common.title') }}</label>
                                    <b-form-input
                                        v-model="link_title"
                                        :placeholder="$t('common.title')"></b-form-input>
                                </div>

                                <div class="form-group">
                                    <label>{{ $t('quest.link_to_file_or_webpage') }}</label>
                                    <b-form-input
                                        v-model="link_url"
                                        placeholder="Url"></b-form-input>
                                </div>

                                <div class="form-group">
                                    <label>&nbsp;</label>
                                    <button
                                        class="btn btn-sm btn-primary"
                                        @click="addLink">
                                        {{ $t('common.save') }}
                                    </button>
                                </div>

                                <div
                                    class="links"
                                    v-if="usermission.links.length > 0">
                                    <div
                                        class="link-item"
                                        v-for="link in usermission.links">
                                        <div class="link-content">
                                            <div class="icon btn-external"></div>
                                            <div class="link-title">{{ link.name }}</div>
                                            <a
                                                class="clickable"
                                                :href="link.url"
                                                target="_blank"></a>
                                        </div>
                                        <b-button
                                            class="btn-remove btn-remove-link"
                                            v-b-tooltip.hover
                                            variant="danger-icon-only"
                                            :title="$t('common.delete')"
                                            @click="deleteLink(link.id)">
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="panel panel-default"
            v-if="preview === 0 && canEdit">
            <div class="panel-body">
                <span style="text-align: center">
                    <h4>
                        {{
                            $t(
                                'quest.have_you_submitted_everything_above_then_click_on_the_button_below_to_submit_the_assignment',
                            )
                        }}
                    </h4>
                    <div class="submit-quest">
                        <button
                            class="btn btn-success"
                            @click="finishMission()">
                            <i
                                class="fas fa-check"
                                aria-hidden="true"></i>
                            {{ $t('quest.submit_assignment') }}
                        </button>
                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import Design2021ApprenticeDisplayHtmlComponent from '../common/design-2021-apprentice-display-html-component';

export default {
    name: 'design-2021-quest-user-mission-component',
    components: { Design2021ApprenticeDisplayHtmlComponent },
    props: ['projectId', 'usermissionIn', 'quest', 'preview'],
    data() {
        //set default skill values
        for (var i = 0; i < this.quest.skills.length; i++) {
            if (this.quest.skills[i].values.length == 0) {
                this.quest.skills[i].values[0] = {};
                this.quest.skills[i].values[0].value = '';
            }
        }

        return {
            usermission: this.usermissionIn,
            mission: this.usermissionIn.mission,
            canEdit: this.usermissionIn.status == 1,
            files: null,
            link_title: '',
            link_url: '',
        };
    },
    methods: {
        getColWidth() {
            let col = 'col-md-6';

            if (this.mission.files.length == 0 && this.quest.skills.length == 0) {
                col = 'col-md-12';
            } else if (this.mission.files.length > 0 || this.quest.skills.length > 0) {
                col = 'col-md-9';
            }

            return col;
        },
        goToLink(url) {
            window.open(url, '_blank');
        },
        goToFile(url) {
            window.open(url, '_blank');
        },
        addLink() {
            this.alert.saving();

            let data = {
                title: this.link_title,
                url: this.link_url,
                id: this.usermission.id,
            };

            this.axios.post(this.routes.questUserLinksAdd(this.projectId, this.usermission.mission_id), data).then(
                (response) => {
                    this.link_title = '';
                    this.link_url = '';
                    this.usermission.links = response.data.links;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        deleteLink(id) {
            this.alert
                .confirm(this.$t('quest.delete_link'), this.$t('quest.are_you_sure_you_want_to_delete_this_link'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        var data = {
                            id: this.usermission.id,
                            link_id: id,
                        };

                        this.axios.post(this.routes.questUserLinksDelete(this.projectId, this.mission.id), data).then(
                            (response) => {
                                this.usermission.links = this.usermission.links.filter((link) => link.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        deleteFile(id) {
            this.alert
                .confirm(this.$t('quest.delete_file'), this.$t('quest.are_you_sure_you_want_to_delete_this_file'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        var data = {
                            id: this.usermission.id,
                            file_id: id,
                        };

                        this.axios.post(this.routes.questUserFilesDelete(this.projectId, this.mission.id), data).then(
                            (response) => {
                                this.usermission.files = this.usermission.files.filter((file) => file.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        uploadFiles() {
            this.alert.saving();

            const headers = { 'Content-Type': 'multipart/form-data' };
            let formData = new FormData();
            formData.append('files', this.files);
            formData.append('id', this.usermission.id);

            this.axios
                .post(this.routes.questUserFilesUpload(this.projectId, this.usermission.mission_id), formData, {
                    headers: headers,
                })
                .then(
                    (response) => {
                        this.files = null;
                        this.usermission.files = response.data.files;
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
        finishMission() {
            this.alert
                .confirm(
                    this.$t('quest.submit_assignment'),
                    this.$t('quest.are_you_sure_you_want_to_delete_this_assignment'),
                    this.$t('quest.yes_submit'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        var data = {
                            id: this.mission.id,
                        };

                        this.axios.post(this.routes.questFinishMission(this.projectId, this.mission.id), data).then(
                            (response) => {
                                this.alert.success();

                                window.location.href = this.routes.quest(this.projectId);
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        cancelMission() {
            this.alert
                .confirm(
                    this.$t('quest.close_assignment'),
                    this.$t('quest.all_submitted_documents_will_be_lost_this_step_is_not_reversible'),
                    this.$t('quest.yes_close_assignment'),
                )
                .then((confirm) => {
                    if (confirm) {
                        window.location.href = this.routes.questCancelMission(
                            this.projectId,
                            this.usermission.mission.id,
                        );
                    }
                });
        },
        getFileType(filetype) {
            switch (filetype) {
                case 'jpeg':
                case 'jpg':
                case 'png':
                case 'jif':
                case 'jfif':
                case 'gif':
                    return 'btn-image-type ';

                case 'pdf':
                    return 'btn-file-type ';

                case 'doc':
                case 'docx':
                    return 'btn-doc-type ';

                case 'ppt':
                case 'pptx':
                    return 'btn-doc-type ';

                case 'xls':
                case 'xlx':
                    return 'btn-doc-type ';

                case 'cda':
                case 'mp3':
                case 'oga':
                    return 'btn-audio-type ';

                case 'mov':
                case 'mpeg':
                case 'mkv':
                case 'ogv':
                case 'webm':
                case '3gp':
                case 'mp4':
                case 'mpeg4':
                    return 'btn-video-type ';

                default:
                    return 'btn-file-type ';
            }
        },
    },
};
</script>

<style scoped lang="scss">
.quest-user-mission-card {
    padding: 0;
    border: 1px solid $border-color;

    .quest-user-mission-card-header {
        background-color: $info;
        color: $white;
        padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'twenty-one');
        border-top-left-radius: $border-radius-content;
        border-top-right-radius: $border-radius-content;

        .title {
            margin-bottom: 0;

            i {
                margin-right: map-get($grid-gutter-spacing, 'ten');
            }
        }
    }

    .quest-user-mission-card-content {
        padding: map-get($grid-gutter-spacing, 'fiften') map-get($grid-gutter-spacing, 'twenty-one')
            map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'twenty-one');

        .info-text {
            color: $text-muted-color;
        }
    }
}

.quest-user-mission-planning-card {
    .quest-user-mission-card-content {
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        p {
            margin-bottom: 0;
        }
    }
}

.group-size {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.quest-assignment-card {
    .description {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
    }

    .attachments {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        .component-title {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        .file {
            display: flex;
            justify-content: flex-start;
            align-content: center;
            font-size: 1.3125rem;

            .icon {
                align-self: center;
                padding: 10px;
                background: $secondary-background-color;
                border-radius: $border-radius-content;
                color: var(--primary);
            }

            .title {
                font-size: $default-font-size;
                font-family: $headings-font-family;
                font-weight: $font-weight-bold;
                margin-left: map-get($grid-gutter-spacing, 'ten');
                margin-right: map-get($grid-gutter-spacing, 'ten');
                align-self: center;
                word-break: break-word;

                .file-size {
                    font-size: 0.75rem;
                    font-weight: $font-weight-normal;
                }
            }

            .download-file {
                display: flex;
                align-items: center;
                align-self: center;
                margin-left: auto;

                .btn-file-download {
                    font-size: 1.3125rem;

                    &:before {
                        margin-right: 0;
                    }
                }
            }

            &:not(:last-child) {
                margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }

    .links {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        .component-title {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        .links-items {
            display: flex;
            flex: 1 0 100%;
            flex-direction: column;
            justify-content: space-between;
            margin-bottom: map-get($grid-gutter-spacing, 'ten');

            .link-item {
                display: flex;
                flex: 1 0 100%;
                justify-content: space-between;

                .link-name {
                    font-weight: $font-weight-medium;
                }
            }
        }
    }
}

.quest-user-mission-send-in-card {
    .quest-mission-send-in-tab {
        .nav-item {
            .nav-link {
                background-color: transparent;

                &.active {
                    background-color: transparent;
                    font-weight: $font-weight-bold;
                }
            }
        }
    }
}

.panel-default {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');

    .submit-quest {
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    }
}

.files {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
    gap: 0 15px;

    .uploaded-file {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        font-size: 1.125rem;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        width: 100%;

        .icon {
            align-self: flex-start;
            padding: map-get($grid-gutter-spacing, 'ten');
            background: $secondary-background-color;
            border-radius: $border-radius-content;
            color: var(--primary);

            &:before {
                margin-right: 0;
            }
        }

        .title {
            font-size: $default-font-size;
            font-weight: $font-weight-bold;
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
            align-self: center;
            word-break: break-word;
        }

        .actions {
            display: flex;
            align-items: center;
            align-self: flex-start;
            margin-left: auto;

            .btn {
                padding-top: 4px;
            }
        }

        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'eight');
            padding-bottom: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

.link-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-content: center;
    font-size: $base-font-size;
    border: 0;
    border-radius: $border-radius-content;
    padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'twenty-one')
        map-get($grid-gutter-spacing, 'eight') 0;

    .link-content {
        display: flex;
        flex-direction: row;
    }

    .icon {
        align-self: flex-start;
        padding: map-get($grid-gutter-spacing, 'ten');
        background: $secondary-background-color;
        border-radius: $border-radius-content;
        color: var(--primary);

        &:before {
            margin-right: 0;
        }
    }

    .link-title {
        font-size: $default-font-size;
        align-self: center;
        margin-left: map-get($grid-gutter-spacing, 'fifteen');
        color: $text-muted-color;
        font-weight: $font-weight-medium;
    }

    .btn-remove-link {
        align-self: center;
    }

    &:hover {
        background-color: $secondary-background-color;
        border-radius: $border-radius-content;
    }

    &:not(:last-child) {
        border-bottom: 3px dotted $border-color;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .panel-default {
        .submit-quest {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .quest-assignment-card {
        .attachments {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;

            .component-title {
                flex: 1 0 100%;
            }

            .file {
                width: calc(50% - 15px);
            }
        }

        .links {
            margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;

            .component-title {
                flex: 1 0 100%;
            }

            .links-items {
                flex-direction: row;
                flex-wrap: wrap;
                flex: 1 0 100%;

                .link-item {
                    flex: 0 1 calc(50% - 15px);
                    width: calc(50% - 15px);
                }
            }
        }
    }

    .files {
        .uploaded-file {
            width: calc(33.3% - 15px);
        }
    }

    .link-item {
        max-width: 50%;
    }

    /* Safari Only media Queries */
    _::-webkit-full-page-media,
    _:future,
    :root {
        .files {
            .uploaded-file {
            }
        }
    }

    @media not all and (min-resolution: 0.001dpcm) {
        .files {
            .uploaded-file {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}
</style>
